import { FILTER_TYPES } from 'components/FilterPod';

const filters = () => [
  {
    title: 'وضعیت',
    label: 'وضعیت',
    keyName: 'status',
    query: 'status',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [],
    },
  },
  {
    title: 'تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    query: {
      start: 'fromDate',
      end: 'toDate',
    },
    id: {
      start: 1, // fake
      end: 2, // fake
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  // {
  //   title: 'شناسه درخواست',
  //   label: 'شناسه درخواست',
  //   keyName: 'workItemId',
  //   query: 'workItemId',
  //   id: 1,
  //   value: null,
  //   filterType: FILTER_TYPES.text,
  //   filterProps: { dir: 'ltr', englishNumber: true },
  // },
  {
    title: 'موضوع',
    label: 'موضوع',
    keyName: 'title',
    query: 'title',
    id: 2,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
];

export default filters;
